export const base = document.body.dataset.context || ""

export async function load(url: string, post:any = null){
    var options:RequestInit = {cache:"no-cache"}
    var headers:any = {cache:"no-cache"};

    if(post){
        options.method = "post";
        if(post instanceof FormData) {
            options.body = post;
        } else {
            headers = {...headers, "content-type": "application/json"}
            options.body = JSON.stringify(post);
        }
    }

    options.headers = headers;

    const res = await fetch(base + url, options)

    const result =  await res.json()
    if(result.error)
        throw result.error
    return result;
}
export type Course = {
    name: string
    slug: string
    type: string
    modality: ("Ead"|"College")[]
}

export type CourseList = {courses:Record<string, Course[]>}

export async function loadCourses(){
    return (await load("/api/traits/list-courses")) as CourseList
}

export async function appendLead(lead:any){
    return (await load("/api/traits/append-lead", lead)) as CourseList
}


(window as any).loadCourses = loadCourses


export function courseToLink(course:Course){
    return `${base}/${course.modality.includes('Ead') ? 'ead' : 'graduacao'}/${course.slug}`;
}